<template>
  <div>
      <ListagemPerfilRotaComponent />
  </div>
</template>

<script>

import ListagemPerfilRotaComponent from '../components/ListagemPerfilRotaComponent.vue';

export default {
  components: { ListagemPerfilRotaComponent },
  name: 'PerfilRotaPage'
}
</script>
